<script>
import TopBar from "@layouts/top-bar";
import NavBar from "@layouts/nav-bar";
import PageHeader from "@layouts/page-header";
import RightBar from "@layouts/right-bar";
import Footer from "@layouts/footer";

export default {
  components: {
    TopBar,
    NavBar,
    PageHeader,
    RightBar,
    Footer
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => {
        return [];
      }
    },
    alertVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isMenuOpened: false
    };
  },
  computed: {
    alert() {
      return this.$store.state.alert;
    },
    modal() {
      return this.$store.state.modal;
    },
    showAlert() {
      return this.alertVisible && this.alert.show && !this.modal.isVisible;
    }
  },
  created() {
    this.$store.dispatch("modal/clear");
    this.$store.dispatch("alert/clear");
  },
  methods: {
    toggleMenu() {
      this.isMenuOpened = !this.isMenuOpened;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    closeAlert() {
      this.$store.dispatch("alert/clear");
    }
  }
};
</script>

<template>
  <div>
    <header id="topnav">
      <TopBar>
        <NavBar :is-menu-opened="isMenuOpened" />
      </TopBar>
      <PageHeader :title="title" :items="items" />
    </header>

    <div class="wrapper">
      <div class="container-fluid">
        <b-alert
          variant="danger"
          dismissible
          :show="showAlert"
          @dismissed="closeAlert"
        >
          {{ alert.message }}
        </b-alert>
        <slot />
      </div>
      <Footer />
      <RightBar />
    </div>
  </div>
</template>
